<template>
    <div v-html="squareBanner"></div>
</template>


<script>

    export default {
        name: 'squareBanner',
        data() {
            return {
                squareBanner: null
            }
        },
        mounted() {

            this.axios.get(this.$store.state.SquareBannerNetworkHTMLCodeApi).then((response) => {
                this.squareBanner = response.data.HTMLCode;
            }).catch((error) => { })


        }
    }
</script>